import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  description?: string;
  crumbs?: Crumb[];
  children?: ReactNode;
}

export default function PageHeader({ title, description, crumbs, children }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        {crumbs && crumbs.length > 0 && (
          <nav className="mb-4 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
            {crumbs.map((crumb, index) => (
              <span key={`${crumb.label}-${index}`} className="flex items-center gap-1.5">
                {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
                {crumb.path ? (
                  <Link to={crumb.path} className="cursor-pointer hover:text-primary-700">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700">{crumb.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h1>
        {description && <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>}
        {children}
      </div>
    </section>
  );
}